import { useEffect } from 'react';
import { GIC_LIFECYCLE_EVENTS } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/constants.tsx';
import { useGICLifeCycleEvents } from '@atlassian/jira-issue-create-extensibility/src/common/utils/lifecycle-events/main.tsx';
import { useFormContext } from './index.tsx';

export const usePublishFormContext = (): void => {
	const [state] = useFormContext();
	const { publish } = useGICLifeCycleEvents();

	useEffect(() => {
		publish(GIC_LIFECYCLE_EVENTS.FORM_CONTEXT_STATE_CHANGE, state);
	}, [publish, state]);
};
